__turbopack_context__.v({
  "l": "Spinner-module-scss-module__hP9PFa__l",
  "m": "Spinner-module-scss-module__hP9PFa__m",
  "s": "Spinner-module-scss-module__hP9PFa__s",
  "spin": "Spinner-module-scss-module__hP9PFa__spin",
  "spinner": "Spinner-module-scss-module__hP9PFa__spinner",
  "xl": "Spinner-module-scss-module__hP9PFa__xl",
  "xs": "Spinner-module-scss-module__hP9PFa__xs",
});
